/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Image_Default_MiniappInputs */

const vi_shop_group_image_default_miniapp = /** @type {(inputs: Shop_Group_Image_Default_MiniappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mặc định (Mini App)`)
};

/**

* @param {Shop_Group_Image_Default_MiniappInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_image_default_miniapp = /** @type {((inputs?: Shop_Group_Image_Default_MiniappInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Image_Default_MiniappInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_image_default_miniapp(inputs)
});